import React from "react";

export function Footer() {
  return (
    <footer
      data-testid="app-footer"
      className="mt-auto border-t border-border bg-white px-6 md:px-8 py-4"
    >
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
        <div className="flex items-center gap-2 shrink-0">
          <span className="font-display text-sm font-bold text-navy tracking-tight">ComplyX Gov</span>
          <span className="text-[10px] uppercase tracking-[0.2em] text-gold-dark border border-gold/40 rounded px-1.5 py-0.5">
            v1.0 Internal
          </span>
        </div>
        <p className="text-[11px] leading-relaxed text-muted-foreground md:border-l md:border-border md:pl-4">
          ComplyX Gov provides readiness support, documentation assistance, and assessment preparation services.
          Formal CMMC certification assessments must be conducted independently by an{" "}
          <span className="text-navy font-medium">authorized C3PAO</span>.
        </p>
      </div>
    </footer>
  );
}
